// extracted by mini-css-extract-plugin
module.exports = {"rp-cogs":"_28Qj_TQ6iLbHaEXxjBTesR","input-cogs":"_1vZsn-FMhMPiJY57LgY_Tv"};